<script setup lang="ts">
  import { type AccessRole } from '@gat-ship/types'
  import type { RouteLocationAsRelative } from 'vue-router'
  import {
    DataList,
    DataListItem,
    DataListItemDescription,
    DataListItemTitle
  } from '@gat-ship/vue-components'
  import { useAccessRolesCollectionProvider } from '../providers/access-roles-collection-context'

  // Router-agnostic list body shared by the routed AccessRolesView (under its
  // PageLayout chrome) and the AdministrationModal access-roles panel. Two
  // row-click modes: the routed view passes `to`, so rows render as RouterLinks
  // (preserving native middle-click + the chevron affordance); the panel omits
  // `to` and listens to `select` to open the detail modal layered over the
  // admin modal. The list reads the collection from the reka context and
  // exposes `openAdd` for the host's header button.
  const props = defineProps<{
    to?: (accessRole: AccessRole) => RouteLocationAsRelative
  }>()

  const emit = defineEmits<{
    (e: 'select', accessRole: AccessRole): void
  }>()

  const { dataSource, modals } = useAccessRolesCollectionProvider()

  function onItemClick(accessRole: AccessRole) {
    if (!props.to) {
      emit('select', accessRole)
    }
  }

  function openAdd() {
    modals.showAddAccessRole({})
  }

  defineExpose({
    openAdd
  })
</script>

<template>
  <DataList>
    <DataListItem
      v-for="accessRole in dataSource.accessRoles.value"
      :key="accessRole.id"
      :to="to ? to(accessRole) : undefined"
      @click:item="onItemClick(accessRole)"
    >
      <DataListItemTitle>
        {{ accessRole.name }}
      </DataListItemTitle>
      <DataListItemDescription>
        {{ accessRole.description }}
      </DataListItemDescription>
    </DataListItem>
  </DataList>
</template>
